import { useToast } from '@/hooks/use-toast';

export type NotificationType = 'success' | 'error' | 'warning' | 'info';

interface NotificationOptions {
  title: string;
  description?: string;
  duration?: number;
}

export const useNotifications = () => {
  const { toast } = useToast();

  const showNotification = (type: NotificationType, options: NotificationOptions) => {
    const { title, description, duration = 4000 } = options;
    
    const variants: Record<NotificationType, 'default' | 'destructive'> = {
      success: 'default',
      error: 'destructive',
      warning: 'default',
      info: 'default'
    };

    toast({
      title,
      description,
      duration,
      variant: variants[type],
    });
  };

  const success = (options: NotificationOptions) => 
    showNotification('success', options);

  const error = (options: NotificationOptions) => 
    showNotification('error', options);

  const warning = (options: NotificationOptions) => 
    showNotification('warning', options);

  const info = (options: NotificationOptions) => 
    showNotification('info', options);

  return {
    success,
    error,
    warning,
    info,
    showNotification
  };
};